import React from 'react';

import { Box, Modal, Typography, Button } from '@mui/material';

import close from '../../../../assets/images/orange_x.svg';
import arrows from '../../../../assets/images/arrows.svg';

const BP1 = '@media (max-width: 899px)';
const BP2 = '@media (max-width: 719px)';
const BP3 = '@media (max-width: 600px)';
const BP4 = '@media (max-width: 430px)';
const BP5 = '@media (max-width: 408px)';

const sx = {
  root: {
    height: '100%',
    backgroundColor: '#152d2ebf',
    px: '125px',
    position: 'relative',
    pointerEvents: 'none',
    transition: 'all .3s',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '30px',
    [BP1]: {
      px: '85px',
    },
    [BP2]: {
      px: '25px',
    },
  },
  img: {
    height: '100%',
    width: '100%',
    objectFit: 'contain',
  },
  closeBtn: {
    position: 'relative',
    width: '100%',
    cursor: 'pointer',
    pointerEvents: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    pr: '70px',
    [BP3]: {
      pr: '20px',
    },
  },
  buttonBox: {
    display: 'flex',
    flexDirection: 'row',
    gap: '5px',
    maxWidth: '200px',
  },
  title: {
    fontFamily: 'boucherie-block',
    fontSize: '46px',
    fontWeight: '700',
    textAlign: 'center',
    color: '#FF692B',
    lineHeight: '50px',
    mb: '30px',
    [BP3]: {
      fontSize: '39px',
      mb: '20px',
    },
    [BP4]: {
      fontSize: '35px',
    },
  },
  description: {
    fontFamily: 'bau',
    maxWidth: '387px',
    textAlign: 'center',
    fontSize: '16px',
    lineHeight: '24px',
    mb: '30px',
    [BP3]: {
      maxWidth: '350px',
    },
    [BP4]: {
      maxWidth: '300px',
    },
    [BP5]: {
      px: '20px',
    },
  },
  content: {
    maxWidth: '508px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#CACCB5',
    padding: '30px 10px 40px 10px',
    borderRadius: '15px',
    outline: 'solid 2px #D2D4C2',
    outlineOffset: '12px',
    pointerEvents: 'auto',
    [BP3]: {
      maxWidth: '450px',
    },
  },
  closeBox: {
    display: 'flex',
  },
  button: {
    backgroundColor: '#CACCB5',
    color: '#FF692B',
    border: 'solid 3px #FF692B',
    mt: '30px',
    '&:hover': {
      backgroundColor: '#FF692B',
      border: 'solid 3px #FF692B',
      color: '#FFF',
    },
  },
};

const InformationModal = ({ isOpen, setOpen }) => {
  return (
    <Modal
      open={isOpen}
      onClose={(event, reason) => {
        setOpen(false);
      }}
    >
      <Box
        sx={sx.root}
        style={{
          display: 'flex',
          jusifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box sx={sx.content}>
          <Box
            sx={sx.closeBtn}
            onClick={() => {
              setOpen(false);
            }}
          >
            <img
              src={close}
              style={{ width: '16px', cursor: 'pointer' }}
              alt="Close"
            />
          </Box>
          <Typography sx={sx.title}>Multiple cards</Typography>

          <Typography sx={sx.description}>
            You have multiple character cards eligible to complete the
            collection. Please select the card you wish to use by clicking on
            the left and right arrow keys.
          </Typography>
          <img src={arrows} />
          <Box sx={sx.buttonBox}>
            <Button
              variant="contained"
              sx={sx.button}
              onClick={(event, reason) => {
                setOpen(false);
              }}
            >
              Understood
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default InformationModal;
